import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import avatar1 from "../../assets/images/users/avatar-user.png";
import { Link, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getUserByEmail } from '../../modules/Users/services/userApi'
import { DownOutlined } from '@ant-design/icons';

const ProfileDropdown = () => {
    const navigate = useNavigate();
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
    const email = currentUser?.email;
    const { data: user } = useQuery(
        ["user", email], 
        ()=> getUserByEmail(email),
        {
            enabled : !!email
        }
    );

    const fileName = user?.fileName;

    const handleLogout = () => {
        const email = currentUser?.email;
        sessionStorage.removeItem("authUser");
        sessionStorage.removeItem("token");
        if (email) {
            sessionStorage.setItem("email", email);
        }
        if (user) {
            sessionStorage.setItem("user", JSON.stringify(user));
        }
        navigate("/lock", { state: { email, user } });
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" 
                            src={fileName ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${fileName}` : avatar1}
                            alt="HeaderSection Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{currentUser?.fullName || "-"}</span>
                        </span>
                        <span className="ms-2">
                            <DownOutlined />
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">{currentUser?.email}</h6>
                    <DropdownItem className='p-0'>
                        <Link to={`/profiles`} className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Mon Profil</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/help" className="dropdown-item">
                            <i className="bx bx-help-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Besoin d'aide ?</span>
                        </Link>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0' onClick={handleLogout}>
                        <a className="dropdown-item">
                            <i className="ri-lock-2-line text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Vérouiller</span>
                        </a>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "/logout"} className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Se déconnecter</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;